<template>
  <div class="couponReceive" :style="bgColor">

    <div class="coupon-list coupon-style1" :class="datas.layout" v-if="datas.csstype=='style1'">
      <div class="item" v-for="(item,i) in coupon" :key="i" @click="receiveSCCoupon(item)" :style="item.couponBg?item.couponBg:imgBg" v-if="item.canUse&&item.canUse=='T'">
        <div class="coupon-info" >
          <div class="lf">
            <div class="price" v-if="item.allTotal"><i>￥</i>{{item.allTotal}}</div>
            <div class="price" v-else-if="item.discountNum"><i v-if="item.discountTypeDesc!='Z'">￥</i>{{item.discountNum}}<i v-if="item.discountTypeDesc=='Z'">折</i></div>
          </div>
          <div class="rt">
            <div class="name" v-if="item.descript">{{item.descript}}</div>
            <div class="name" v-else-if="item.couponName">{{item.couponName}}</div>
            <!-- <div class="btn-txt" :style="mainColor">立即领取</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="coupon-list coupon-style2" :class="datas.layout" v-if="datas.csstype=='style2'">
      <div class="item" v-for="(item,i) in coupon" :key="i" @click="receiveSCCoupon(item)" :style="item.couponBg?item.couponBg:imgBg" v-if="item.canUse&&item.canUse=='T'">
        <div class="coupon-info" :style="item.mainColor?item.mainColor:mainColor">
          <div class="lf">
            <div class="price" v-if="item.allTotal"><i>￥</i>{{item.allTotal}}</div>
            <div class="price" v-else-if="item.discountNum"><i v-if="item.discountTypeDesc!='Z'">￥</i>{{item.discountNum}}<i v-if="item.discountTypeDesc=='Z'">折</i></div>
          </div>
          <div class="rt">
            <div class="name" v-if="item.descript">{{item.descript}}</div>
            <div class="name" v-else-if="item.couponName">{{item.couponName}}</div>
            <!-- <div class="btn-txt">立即领取</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="coupon-list coupon-style3" :class="datas.layout" v-if="datas.csstype=='style3'">
      <div class="item" v-for="(item,i) in coupon" :key="i" @click="receiveSCCoupon(item)" :style="item.couponBg?item.couponBg:imgBg" v-if="item.canUse&&item.canUse=='T'">
        <div class="coupon-info" :style="item.mainColor?item.mainColor:mainColor">
          <div class="lf">
            <div class="name"></div>

            <div class="price" v-if="item.allTotal"><i>￥</i>{{item.allTotal}}</div>
            <div class="price" v-else-if="item.discountNum"><i v-if="item.discountTypeDesc!='Z'">￥</i>{{item.discountNum}}<i v-if="item.discountTypeDesc=='Z'">折</i></div>
          </div>
          <div class="rt">
            <div class="name" v-if="item.descript">{{item.descript}}</div>
            <div class="name" v-else-if="item.couponName">{{item.couponName}}</div>
            <!-- <div class="btn-txt">立即领取</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="coupon-list coupon-style4" :class="datas.layout" v-if="datas.csstype=='style4'">
      <div class="item" v-for="(item,i) in coupon" :key="i" @click="receiveSCCoupon(item)" :style="item.couponBg?item.couponBg:imgBg" v-if="item.canUse&&item.canUse=='T'">
        <div class="coupon-info" :style="item.mainColor?item.mainColor:mainColor">
          <div class="lf">
            <div class="name" v-if="item.descript">{{item.descript}}</div>
            <div class="name" v-else-if="item.couponName">{{item.couponName}}</div>
          </div>
          <div class="rt">
            <div class="price" v-if="item.allTotal"><i>￥</i>{{item.allTotal}}</div>
            <div class="price" v-else-if="item.discountNum"><i v-if="item.discountTypeDesc!='Z'">￥</i>{{item.discountNum}}<i v-if="item.discountTypeDesc=='Z'">折</i></div>
            <!-- <div class="btn-txt">立即领取</div> -->
          </div>

        </div>
      </div>
    </div>
    <div class="coupon-list coupon-style5" :class="datas.layout" v-if="datas.csstype=='style5'">
      <div class="item" v-for="(item,i) in coupon" :key="i" @click="receiveSCCoupon(item)" :style="item.couponBg?item.couponBg:imgBg" v-if="item.canUse&&item.canUse=='T'">
        <div class="coupon-info" :style="item.mainColor?item.mainColor:mainColor">
          <div class="lf">
            <div class="price" v-if="item.allTotal"><i>￥</i>{{item.allTotal}}</div>
            <div class="price" v-else-if="item.discountNum"><i v-if="item.discountTypeDesc!='Z'">￥</i>{{item.discountNum}}<i v-if="item.discountTypeDesc=='Z'">折</i></div>
          </div>
          <div class="rt">
            <div class="name" v-if="item.descript">{{item.descript}}</div>
            <div class="name" v-else-if="item.couponName">{{item.couponName}}</div>
            <!-- <div class="btn-txt">立即领取</div> -->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// 菜单项
import { jAlert3, jAlert5 } from '@/base/jAlert/jAlert';
import { createUrl } from "@/utils/index";
import { setStorage, getStorage } from '@/utils/wxuser';
import api from '@/utils/api';
import gcTrack from "@/utils/gcTrack";
var config = {};
export default {
  props: ['datas'],
  data() {
    return {
      wxuser: getStorage('wxuser'),
      user: getStorage('user'),
      coupon: []
    };
  },
  methods: {
    receiveSCCoupon(coupon) {
      if (this.isLogin()) {
        var opt = {
          couponCode: coupon.code || coupon.couponCode,
          hotelGroupCode: config.hotelGroupCode,
          hotelGroupId: config.hotelGroupId,
          hotelCode: coupon.hotelCode,
          memberId: this.user.memberId,
          appid: config.appid,
          openid: this.wxuser.openid,
          couponType: coupon.couponType,
          mobile:this.user.mobile
        };
        this.getCurrentCard();
        var chuzhiIndex = getStorage("cardIndex") || 0;
        opt.cardId = this.user.cardListDto[chuzhiIndex].cardId;
        opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
        opt.cardNo = this.user.cardListDto[chuzhiIndex].cardNo;
        opt.url = createUrl(opt)
        api.receiveSCCouponNew(opt).then(res => {
          if (res.result == 1) {
            gcTrack.track("SC_ReceiveDiscount", {
              discount_id: coupon.id,
              discount_name: coupon.name,
              discount_amount: coupon.presentValue,
              discount_type: coupon.couponType
            })
            this.getCouponDetail(coupon);
            jAlert3('领取成功');
          } else {
            jAlert3(res.msg);
          }
        });
      }
    },
    getCouponDetail(item) {
      if (item.couponType == 'coupon') {
        var couponType = 'C';
      }
      if (item.couponType == 'pack') {
        var couponType = 'P';
      }
      var obj = {
        hotelCode: config.hotelCode,
        hotelGroupCode: config.hotelGroupCode,
        code: item.code || item.couponCode,
        type: couponType,
        appid: config.appid,
        componentAppid: config.componentAppid,
        memberId: ''
      };
      if(this.user && this.user.memberId){
        obj.memberId = this.user.memberId;
      }
      api.getCouponDetail(obj).then(res => {
        if (res.result == 1) {
         
          item.discountTypeDesc = ''
          item.canReceived = res.retVal.canReceived
          item.descript = res.retVal.descript
          item.discountType = res.retVal.discountType
          item.discountNum = res.retVal.discountNum
          if (item.discountType == 'MZ' || item.discountType == 'LZ') {
            item.discountNum = parseFloat((item.discountNum * 10).toFixed(2))
            item.discountTypeDesc = 'Z'
          }
          if(this.user&&this.user.memberId){ 
            if(item.canReceived!='T'){
              this.$set(item,'mainColor', `color: #eee;`)
              this.$set(item,'couponBg', `background: url(https://xcx.ihotel.cn/mall/images/coupon_${this.datas.csstype}.png) no-repeat;`)
            
            }
          }
          
          this.$set(item,'canUse','T')
          // if (this.user && this.user.memberId) {
          //   this.coupon.push(item);
          // } else {
          //   this.coupon.push(item);
          // }

        }
      });

    }
  },
  computed: {
    bgColor() {
      let style = ""
      if (this.datas.backgroundColor) {
          style += `background:${this.datas.backgroundColor};`
      }
      return style
    },
    mainColor() {
      return `color: ${this.datas.textColor};`
    },
    imgBg() {
      return `background: url(${this.datas.calcUrl}) no-repeat;`

    }
  },
  mounted() {
    if (this.datas.items) {
      this.coupon = this.datas.items
      this.coupon.forEach((item, i) => {
        this.getCouponDetail(item);
      });
    }
  },
  created() {
    console.log(this.datas)

    config = getStorage('config');
  }
};
</script>
<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");
.couponReceive {
  .coupon-list {
    padding: 0 0.133333rem;
    &.one,
    &.two,
    &.three {
      display: flex;
      flex-wrap: wrap;
      padding: 0 0.4rem;
    }
    &.mult {
      white-space: nowrap;
      padding: 0 0.133333rem;
      overflow-x: scroll;
      overflow-y: hidden;
    }
    &.grid {
      padding: 0 0.4rem;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .item {
      margin: 0.133333rem;
      position: relative;
      display: inline-block;
      overflow: hidden;
      box-sizing: border-box;
      text-align: center;
      background-size: contain !important;
      .coupon-info {
        position: relative;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: space-between;
      }
      .lf {
        width: 1.9rem;
        text-align: center;
        display: inline-block;
        .name {
          text-align: center;
        }
      }
      .price {
        font-size: 20px;
        white-space: normal;
        font-family: PingFangSC-Medium;
        i {
          font-size: 14px;
        }
      }
      .rt {
        position: relative;
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;

        align-items: center;
        .name {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          font-family: PingFangSC-Medium;
          margin-top: 0.213333rem;
          padding: 0 0.133333rem;
          box-sizing: border-box;
          text-align: center;
          font-size: 10px;
          line-height: 0.373334rem;
          height: 0.746668rem;
          overflow: hidden;
          width: 100%;
        }

        .btn-txt {
          display: flex;
          justify-content: center;
          width: 1.6rem;
          position: absolute;
          left: 0.72rem;
          bottom: 0.213333rem;
          border-radius: 9px;
          font-size: 10px;
          font-family: PingFangSC-Medium;
          border-radius: 9px;
          line-height: 0.48rem;
        }
      }
    }
    &.coupon-style1 {
      .item {
        color: #fff;
        width: 4.32rem;
        height: 1.76rem;
        .coupon-info {
          .price {
            font-size: 16px;
            i {
              font-size: 10px;
            }
          }
        }
      }
    }
    &.coupon-style2 {
      .item {
        width: 4.32rem;
        height: 1.76rem;
        .coupon-info {
          .price {
            width: 1.546667rem;
            font-size: 16px;
            i {
              font-size: 10px;
            }
          }
          .rt {
            .name {
              padding-left: 0.266667rem;
            }
            .btn-txt {
              left: 0.9rem;
              color: #fff;
            }
          }
        }
      }
    }
    &.coupon-style3 {
      justify-content: flex-start;
      .item {
        width: 2.8rem;
        height: 3.333333rem;
        color: #d62b24;

        .coupon-info {
          flex-direction: column;
          .lf {
            width: 2.373333rem;
            padding: 0 0.133333rem;
            .name {
              font-size: 10px;
              line-height: 0.373333rem;
              height: 0.373333rem;
              overflow: hidden;
              margin-top: 0.16rem;
              width: 100%;
              box-sizing: border-box;
            }
            .price {
              margin-top: 0.133333rem;
              font-size: 22px;
              font-weight: bold;
              i {
                font-size: 12px;
                font-weight: bold;
              }
            }
          }
          .rt {
            width: 100%;
            .name {
              position: absolute;
              color: #fff;
              bottom: 0.7rem;
              font-size: 12px;
              line-height: 20px;
              height: 20px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .btn-txt {
              width: 1.333333rem;
              left: 0.746667rem;
              bottom: 0.106667rem;
              font-size: 8px;
            }
          }
        }
      }
    }
    &.coupon-style4 {
      .item {
        width: 8.933333rem;
        color: #fff;
        height: 2.346667rem;
        .coupon-info {
          .lf {
            padding-left: 0.693333rem;
            padding-right: 0.266667rem;
            box-sizing: border-box;
            width: 5.4rem;
            text-align: left;
            font-size: 15px;
            color: #ffffff;
            line-height: 0.64rem;
            max-height: 1.28rem;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            .name {
              word-break: break-all;
            }
          }
          .rt {
            .price {
              margin-top: 0.45rem;
              font-size: 25px;
              i {
                font-size: 12px;
              }
            }
            .btn-txt {
              position: absolute;
              font-size: 8px;
              color: #ffffff;
              left: 1.1rem;
              bottom: 0.42rem;
            }
          }
        }
      }
    }
    &.coupon-style5 {
      .item {
        width: 8.933333rem;
        color: #fc819d;
        height: 2.346667rem;
        box-shadow: 6px 0 12px 0 rgba(0, 0, 0, 0.1);
        .coupon-info {
          .lf {
            width: 2.8rem;
            padding: 0 0.3rem;
            .price {
              font-weight: bold;
              font-size: 25px;
              i {
                font-size: 15px;
              }
            }
          }
          .rt {
            justify-content: center;
            .name {
              padding-left: 0.5rem;
              padding-right: 1.6rem;
              box-sizing: border-box;
              font-size: 15px;
              margin-top: 0;
              line-height: 0.64rem;
              max-height: 1.28rem;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              word-break: break-all;
              height: auto;
            }
            .btn-txt {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #ffffff;
              writing-mode: vertical-lr;
              left: auto;
              width: 1.2rem;
              height: 100%;
              right: 0;
              top: 0;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/polymerization/couponReceive.vue